/**
 * Time formatting utilities.
 */

/**
 * Convert a timestamp to a relative time string (e.g., "5m ago", "2h ago").
 * @param {number|string|Date} timestamp - The timestamp to convert
 * @returns {string} A human-readable relative time string
 */
export const getRelativeTime = (timestamp) => {
  const now = new Date();
  const msgDate = new Date(timestamp);
  const diffMs = now - msgDate;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return 'Just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  if (diffHour < 24) return `${diffHour}h ago`;
  if (diffDay < 7) return `${diffDay}d ago`;
  return msgDate.toLocaleDateString();
};
